import { render, staticRenderFns } from "./DonatePage.vue?vue&type=template&id=559c4ea9&scoped=true&"
import script from "./DonatePage.vue?vue&type=script&lang=js&"
export * from "./DonatePage.vue?vue&type=script&lang=js&"
import style0 from "./DonatePage.vue?vue&type=style&index=0&id=559c4ea9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c4ea9",
  null
  
)

export default component.exports